import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/atoms/Buttons";
import { ProfileList } from "@/components/molecules/ProfileList";
import { JoinForm } from "@/components/organisms/JoinForm";
import { request } from "@/lib/api";
import { useQuery } from "@tanstack/react-query";
import { ResponseType } from "@/types/response.types";
import { PROFILE_ID, readProfileId } from "@/lib/authFunctions";
import { GET_CHILD_PROFILE_LIST } from "@/lib/querykeys";
import { MyProfileSelectProps } from "@/pages/mypage/MyProfileSelectPage";
import { navigatorRoutePushScreen } from "@/lib/flutterFuntions";
import { showToast } from "@/components/atoms/CustomToast";
import { MainTemplate } from "@/components/templates/MainTemplate";

export const ProfileSelectLearningPage = () => {
  /** ============================= state 영역 ============================= */
  const navigate = useNavigate();
  const [profile, setProfile] = useState<MyProfileSelectProps>();
  const [selectProfileId, setSelectProfileId] = useState<string>("");

  /** 프로필 리스트  */
  const { data: profileList } = useQuery(
    [GET_CHILD_PROFILE_LIST],
    async () => {
      const result = await request<ResponseType<any>>({
        method: "GET",
        url: `profile`,
      });

      return result.data;
    },
    {
      onError: (error) => {
        console.error("Query Error:", error); // 에러 처리 로직
        // 추가적인 에러 처리 로직
      },
    }
  );

  console.log(profileList);
  /** ============================= 비즈니스 로직 영역 ============================= */
  const handleProfile = (profileId: any, birth_date: any) => {
    // selectProfileId(profileId);
    setSelectProfileId(profileId);

    const birthYear = parseInt(birth_date.slice(0, 4), 10);
    const birthMonth = parseInt(birth_date.slice(4, 6), 10) - 1;
    const birthDay = parseInt(birth_date.slice(6, 8), 10);
    const birthDate = new Date(birthYear, birthMonth, birthDay);

    const today = new Date();
    const yearsDiff = today.getFullYear() - birthDate.getFullYear();
    const monthsDiff = today.getMonth() - birthDate.getMonth();
    const totalMonths = yearsDiff * 12 + monthsDiff;

    // console.log(`아기의 나이는 ${totalMonths}개월 차입니다.`);
    if (totalMonths < 24) {
      localStorage.setItem("age", "0~24");
    } else if (totalMonths > 24 && totalMonths < 36) {
      localStorage.setItem("age", "25~36");
    } else {
      localStorage.setItem("age", "36~");
    }

    return setProfile(profileId);
  };

  /** 입장하기 버튼 핸들러 */
  const handleEnter = async () => {
    localStorage.setItem(PROFILE_ID, selectProfileId);

    const profileId = await readProfileId();

    if (profileId) {
      navigate("/home", { replace: true });
      navigatorRoutePushScreen("/content-dashboard");
    } else {
      showToast("프로필을 선택해 주세요.", "error");
    }
  };

  /** ============================= 컴포넌트 영역 ============================= */

  /** ============================= useEffect 영역 ============================= */

  return (
    <MainTemplate pageTitle="프로필 선택" padding={false} navBar={false}>
      <JoinForm
        alignItems="flex-start"
        subTitle={
          <>
            프로필을 생성 및 선택 후
            <br />
            입장해 주세요.
          </>
        }
        formButton={
          <Button
            type="button"
            width="100%"
            size="full"
            color="primary100"
            layout="solid"
            label="입장하기"
            onClick={handleEnter}
          />
        }
      >
        <ProfileList
          data={profileList}
          // data={dummy}
          onClick={(id: any, birth_date: any) => handleProfile(id, birth_date)}
          selectedProfile={profile}
        />
      </JoinForm>
    </MainTemplate>
  );
};
